import {HoldState} from '@/model/const';
import {ReportData} from '@/pages/report/types';
import Utils from '@/util/utils';

export interface HoldType {
    buyPrice: number;
    holdState: string;
    quantity: number;
    sellPrice: number;
}

const getProfit = (data?: HoldType, report?: ReportData) => {
    if (data) {
        if (data.holdState === HoldState.SOLD) {
            const profit = ((data.sellPrice || 0) - (data.buyPrice || 0)) * (data.quantity || 0);
            return Utils.formatPrice(profit);
        } else if (data.holdState === HoldState.BOUGHT && report && report.latestPrice > 0) {
            const profit = (report.latestPrice - (data.buyPrice || 0)) * (data.quantity || 0);
            return Utils.formatPrice(profit);
        }
    }
    return '--';
};

const getProfitRate = (data?: HoldType, report?: ReportData) => {
    if (data && data.buyPrice > 0) {
        if (data.holdState === HoldState.SOLD) {
            const profit = (data.sellPrice || 0) - data.buyPrice;
            const rate = (profit / data.buyPrice) * 100;
            return Utils.formatPercentage(rate);
        } else if (data.holdState === HoldState.BOUGHT && report && report.latestPrice > 0) {
            const profit = report.latestPrice - data.buyPrice;
            const rate = (profit / data.buyPrice) * 100;
            return Utils.formatPercentage(rate);
        }
    }
    return '--';
};

export default {
    getProfit,
    getProfitRate,
};
